import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "wly6rqdp",
    dataset: "production"
})